import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const CCAArchival = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    
    // Dynamically extract all query parameters without altering case
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value; // Keep keys as they are
    });

    console.log('Extracted Query Parameters:', params); // Log the extracted parameters
    
    fetchArchivalURL(params);
  }, [location]);

  const fetchArchivalURL = async (params) => {
    try {
      console.log('Request parameters:', params);
      const response = await axios.get(`${API_URL}/api/CCAArchival/GetArchivalUrl`, {
        params: {
          ...params
        }
      });

      setLoading(false);
      
      // Use direct navigation instead of form submission
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        setError('cca');
      }
    } catch (error) {
      console.error('Error fetching CCA Archival URL:', error);
      setError('cca');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="cca" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <div className="blockUI">
                  <div 
                    className="blockUI blockOverlay" 
                    style={{
                      margin: '5px', 
                      padding: '0px', 
                      border: 'currentColor', 
                      borderImage: 'none', 
                      left: '0px', 
                      top: '0px', 
                      width: '100%', 
                      height: '100%', 
                      position: 'fixed', 
                      zIndex: 1000, 
                      cursor: 'wait', 
                      opacity: 0.6, 
                      backgroundColor: 'white'
                    }}
                  ></div>
                  <div 
                    className="blockUI blockMsg blockPage" 
                    style={{
                      margin: '5px', 
                      padding: '0px', 
                      border: '#3c8dbc', 
                      borderImage: 'none', 
                      left: '35%', 
                      top: '40%', 
                      width: '30%', 
                      textAlign: 'center', 
                      color: 'rgb(0, 0, 0)', 
                      position: 'fixed', 
                      zIndex: 1011, 
                      cursor: 'wait', 
                      backgroundColor: 'aliceblue', 
                      borderStyle: 'solid', 
                      borderWidth: 'thin', 
                      height: '150px', 
                      fontFamily: 'Calibri'
                    }}
                  >
                    Loading...<br /><br />
                    <img src={LoadingImage} alt="Loading" />
                  </div>
                </div>
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CCAArchival;
